import { render } from "./VolunteerLanding.vue?vue&type=template&id=08c5a434"
import script from "./VolunteerLanding.vue?vue&type=script&lang=js"
export * from "./VolunteerLanding.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__